import { render, staticRenderFns } from "./BusinessNeeds.vue?vue&type=template&id=658cd02c&scoped=true"
import script from "./BusinessNeeds.js?vue&type=script&lang=js&external"
export * from "./BusinessNeeds.js?vue&type=script&lang=js&external"
import style0 from "./BusinessNeeds.scss?vue&type=style&index=0&id=658cd02c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658cd02c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default})
